<style scoped>
  .layout {
    width:100%;
    min-height:100%;
    position: absolute;
    background: url(../../assets/img/mainbg.jpg) center top no-repeat;
  }

  .layout-copy {
    text-align: center;
    padding: 100px 0 20px 0;
    color: #FFF;
    margin-left: -75px;
  }

  .ivu-menu-dark{
    background: rgba(33,33,33,0.8)
  }
  .ivu-dropdown .ivu-select-dropdown{
    top:85px !important;
  }
  .layout-header {
    box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
    height:50px;
    padding-right:5px;
    background: url(../../assets/img/bgtop.jpg) no-repeat;
    background-size: 100%;
  }
  .ivu-menu{
    color:#fff;
  }
  .labBox{
    height:50px;
    width:100%;
    /*margin-bottom:5px;*/
  }

  .ivu-tabs-nav,.ivu-tabs-nav .ivu-tabs-tab-active{
    color:#fff !important;
  }
  .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-submenu:hover{
    background:rgb(35,55,66) !important;
    border-bottom: solid 2px rgb(29,93,167) !important;
  }
  .old-menu-bgc{
    color:rgba(255,255,255,.7) !important;
    background:none !important;
    border-bottom: none !important;
  }

  .imgLogo {
    width: 450px;
    height: 38px;
    box-sizing: border-box;
    text-align: left;
    padding:12px 0 0 30px;
    display: inline-block;
  }

  .imgLogo img{
    height:26px;
  }

  .user-banner {
    float: right;
    vertical-align: middle;
    padding: 6px 15px;
    height: 40px;
  }

  .user-banner-icon {
    vertical-align: middle
  }

  .user-banner-message {
    margin-right: 20px
  }
  a {
    text-decoration: none;
  }

  .ivu-dropdown-rel a{
    color:#fff;
  }
  .bannerRight{
    position: relative;
    left: 10px;
    height: 50px;
    top: -5px;
    margin: 0;
  }
  .bannerRight li{
    height: 50px;
    line-height: 50px;
    color: #fff;
    padding:0 8px;
    display: inline-block;
    cursor: pointer;
  }
  .bannerRight li:hover{
    color: #22b4fa ;
  }
   .bannerRight li:hover .ivu-btn-text{
    color: #22b4fa !important;
  }
  .bannerRight li i{
    margin-right: 2px;
  }
  .ivu-btn-text {
    color: #fff ;
    font-size: 14px;
    padding: 0;
  }

</style>
<template>
  <div class="layout" :class="{'layout-hide-text': spanLeft < 5}">
       <div class="layout-header">
          <div class="imgLogo">
            <img src="../../assets/img/logohen.png" alt="" />
          </div>
          <i-button type="text" @click="toggleClick" style="color: #fff;    position: absolute;top: 10px;left:400px;">
            <Icon type="navicon" size="30"></Icon>
          </i-button>

          <div class="user-banner">
            <ul class="bannerRight">
              <li>
                <Icon type="arrow-swap"></Icon>
                        切换职责
               </li>
               <li @click.native="goto('/changePsw/index')" >
                <Icon type="unlocked"></Icon>
                  <!-- 修改密码 -->
                   <Button @click="modal = true" type="text">修改密码</Button>
                   <Modal v-model="modal" >
                        <change-pwd :userName = 'username'> </change-pwd>

                    <div slot="footer" style="display:none;">

                    </div>
                   </Modal>

               </li>
               <li >
                <Icon type="log-out"></Icon>
                <Button @click.native="logout" type="text">注销</Button>
               </li>
            </ul>
          </div>
        </div>
        <div class="labBox">
          <Menu mode="horizontal" theme="primary" :active-name="activemenu"  ref="contactMenu" style="height:40px;background:none;min-width:930px;">
              <MenuItem :name="index+1" :class="{'ivu-menu-item-active' :  currItemClass[index]}" v-for="(item,index) in menuLists"  style="height:40px;line-height:40px;border-right: solid 1px rgb(8,16,25);background:rgb(26, 41, 73);" @click.native="goto('/'+item.url)" >
                  <Icon :type="item.icon"></Icon>
                  {{item.name}} 
                  <!-- {{item.url}} -->
              </MenuItem>

          </Menu>
        </div>

    <div style="margin-top:-9px;overflow:hidden;">
        <app-content
        :leftLists = "menuLeftLists"
        :currLeft = "currItemLeft"
        :pName="pathName"
        :modName="moduleName"
        :goto="goto"
        :leftHiden="isLeftHiden"  >

        </app-content>
    </div>
  </div>
</template>
<script>
import ChangePwd from '../../components/ChangePwd'
import appContent from '../../components/appContent'
  export default {
    data () {
      return {
        spanLeft: 5,
        spanRight: 19,
        isLeftHiden: false,
        currItemClass:[],
        currItemLeft:[],
        username: '',
        routePath:'',
        pathName:'',
        activemenu:1 ,
        modal:false,
        moduleName:'',
        menuLists:[],
        menuLeftLists:[],

      }
    },
    components: {
      ChangePwd,
      appContent,

    },
    beforeMount () {
      const {body} = document
      const WIDTH = 768;
      const RATIO = 3;
      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH
        }
      }
      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler);
    },
    mounted:function () {
      // console.log(this.menuLists)
      this.menuLists = JSON.parse(localStorage.getItem('menuList'));
      console.log(this.menuLists)
      this.username = sessionStorage.getItem('user');
      this.getPathName()
      this.getLeftBar()
      this.currItem()
    },
    computed: {
      iconSize () {
        return this.spanLeft === 5 ? 14 : 24;
      }
    },
    methods: {
      // 控制刷新menu保持高亮
      currItem(){
        let path = this.$route.matched[1].path  // 获取到地址拦上#号后面的url地址
          let pathMenu = path.split('/')[1];
          // 保持顶部高亮
          var len =  this.menuLists.length;
          if(len !== 0){
            for(var i=0;i<len;i++){
              this.currItemClass[i] = false;
              if(pathMenu.indexOf(this.menuLists[i].url.split('/')[0]) != -1){
                  // 是否包含，-1是包含，0不包含
                  this.currItemClass[i] = true;
                  console.log(238+ i)
              }else{
                  this.currItemClass[i] = false;
              }
            }
          }
          
         // 保持左侧高亮
          var len2 = this.menuLeftLists.length;
          if(len2 !== 0){
            for(var i=0;i<len2;i++){
              this.currItemLeft[i] = false;
              if(path.indexOf(this.menuLeftLists[i].url) != -1){
                // 是否包含，-1是包含，0不包含
                console.log(i)
                  this.currItemLeft[i] = true;
              }else{
                  this.currItemLeft[i] = false;
              }
            }
          }
        

      },
      toggleClick () {
        console.log(this.isLeftHiden);
        this.isLeftHiden = !this.isLeftHiden;
      },
      togglemobileauto(ismobile){
        this.isLeftHiden = ismobile
      },
      logout(){
        sessionStorage.removeItem('smartkitusername');
        sessionStorage.removeItem('islogin');
        this.$router.replace({ path: '/Login' });
      },
      goto(next){
        this.$router.push(next)
        this.getPathName()
        this.getLeftBar()
        this.currItem()
      },
      // guojihua(){
      //   // axios.post(config.)
      // }
      getPathName:function(){
        this.routePath = this.$route.path;
        var arr = this.routePath.split('/')
        this.pathName = arr[arr.length-1];
        return this.pathName;
      },
      getModelName:function(){
        this.routePath = this.$route.path;
        var arr = this.routePath.split('/')
        this.moduleName = arr[arr.length-2];
        return this.moduleName;
      },
      getLeftBar:function(){
        this.getModelName();
        // 采购管理
        var len = this.menuLists.length;
        this.menuLeftLists = [];
        // 动态获取当前模块左侧边栏
        for(var i=0;i<len;i++){
          // console.log(this.menuLists[i])
          if(this.menuLists[i].url.indexOf(this.moduleName) !== -1){
              if(this.menuLists[i].list !== null ){
                this.menuLeftLists = this.menuLists[i].list;
              }
          }

          // 待注释采购业务模拟数据
          if(this.moduleName == 'Procurement'){
          // this.menuLeftLists = this.menuLists[2].list;
            this.menuLeftLists =[
              {
                name: '采购管理',
                icon:'ios-home',
                url:'Procurement/index',
                childMenu:true,
                lists: [
                  {
                    name: '采购合同新增',
                    url:'Procurement/addPurchaseOrder'
                  },
                  {
                    name: '采购合同查询',
                    url:'GatewayUser',
                  },
                  {
                    name: '采购接收新增',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购接收查询',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购入库新增',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购入库查询',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购发票新增',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购发票查询',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购申请新增',
                    url:'GatewayAdmin',
                  },
                  {
                    name: '采购申请查询',
                    url:'GatewayAdmin',
                  }
                ]
              },
              // {
              //   name: '加工管理',
              //   icon:'ios-keypad',
              //   childMenu:false,
              //   url:'Procurement/index',
              //   },
              //   {
              //     name: '销售管理',
              //     icon:'ios-analytics',
              //     url:'Procurement/index',
              // },
              // {
              //     name: '库存管理',
              //     icon:'ios-analytics',
              //     url:'NodeUser',
              //     childMenu:false,
              // },
              // {
              //     name: '基础管理',
              //     icon:'ios-analytics',
              //     url:'NodeUser',

              // }
            ];
          }


          // menu 数据存到localStorage，用于权限设置
          localStorage.setItem('menuLeftLists',JSON.stringify(this.menuLeftLists));
          
        }
        

      },
      
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?2f267ffa